import React from 'react';
import AlertActions from '../../reflux/AlertActions';

export default class RetIva extends React.Component {
    constructor(props) {
        super(props);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.location.pathname == '/retiva/')
        AlertActions.configureAppBar('Retenciones de I.V.A.', null); 
    }
    
    componentWillMount() {
        AlertActions.configureAppBar('Retenciones de I.V.A.', null);   
    }
    
    render() {
        return (<div>{this.props.children}</div>);
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/pages/RetIva/RetIva.jsx
 **/